import React from 'react';
import './Textarea.scss';

export default function Textarea(props) {
  return (
    <div className="form-custom-input">
      <textarea {...props} style={{ height: 130 }} />
    </div>
  );
}
